module.exports = __webpack_public_path__ + "img/20210906-1630911029955884.3f02298d.jpg";